import React from "react";
import { Row, Col } from "react-bootstrap";
import '../../../src/App.css';
import './ContactSection.css';
import call from '../../assets/logo-call.png';
import girl_work from '../../assets/girl-working.png';
import mail from '../../assets/logo-mail.png';
import phone from '../../assets/logo-phone.png';


const ContactSection = () => {
  return(
    <section id="contact-section">
      <Row className="d-flex justify-content-center paddingTop50px">
        <Col lg={5}>
          <img src={girl_work} alt="Icon Girl Working" className="img-fluid img-girl-working"/>
        </Col>
        <Col lg={5} className="text-start">
          <Row>
            <Col lg={12}>
              <img src={call} alt="Call logo" className="img-fluid"/>
              <p className= "font-montserrat text-call fs-2">
                Preparado para
                Trabajar <br/>
                Juntos en Nuevos Proyectos?
              </p>
            </Col>            
          </Row>
          <Row>
            <Col lg={12}>
              <Row>
                <Col xs={2} className="text-start">
                  <img src={phone} alt="phone" className="img-fluid" />
                </Col>
                <Col xs={9} className="font-montserrat fs-4 text-start">
                  <p>+34 626 852 662</p>
                </Col>                
              </Row>
              <Row>
                <Col xs={2} className="text-start">
                  <img src={mail} alt="mail" className="img-fluid" />
                </Col>
                <Col xs={9} className="font-montserrat fs-4 text-start">
                  <p>info@datados.es</p>
                </Col>
              </Row>
              
            </Col>
          </Row>          
        </Col>
      </Row>      
    </section>
  );
};

export default ContactSection;